import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import api from '../../api';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Input, Select } from '../Common';
import { useGetMarketOperators, useGetMarketOperatorsPriceAreas } from '../../hooks';

const CreateFacilityModal = ({ open, setOpen, loadCustomers, filter }) => {
    const secondsInDay = 24 * 3600;
    const linkToWebApp = [
        { label: 'Link to Web App', value: 0 },
        { label: '1 Day', value: secondsInDay },
        { label: '1 Week', value: 7 * secondsInDay },
        { label: '1 Month', value: 30 * secondsInDay },
        { label: '3 Months', value: 3 * 30 * secondsInDay },
    ];

    const [customerNumber, setCustomerNumber] = useState();
    const [facilityNumber, setFacilityNumber] = useState();
    const [address, setAddress] = useState();
    const [marketOperator, setMarketOperator] = useState('');
    const [priceArea, setPriceArea] = useState('');
    const [duration, setDuration] = useState('');
    const [showLink, setShowLink] = useState(false);
    const [link, setLink] = useState('');
    const [error, setError] = useState('');

    const { data: marketOperators } = useGetMarketOperators();
    const { data: priceAreas } = useGetMarketOperatorsPriceAreas(marketOperator);

    const marketOperatorOptions = [{ value: '', label: 'Market Operator', hidden: true }, ...marketOperators.map(op => ({ value: op, label: op }))];

    const priceAreaOptions = [{ value: '', label: 'Price Area', hidden: true }, ...priceAreas.map(area => ({ value: area, label: area }))];

    const handleMarketOperatorChange = e => {
        setMarketOperator(e.target.value);
        setPriceArea('');
    };

    const createFacility = async () => {
        setError('');
        try {
            if (!marketOperator || !priceArea || !customerNumber || !facilityNumber || !address) {
                setError('You must enter customer and facility numbers, address, market operator and price area!');
            } else {
                await api.create_facility(customerNumber, facilityNumber, address, priceArea);
                if (duration === '') {
                    setLink((await api.customer_web_app_link(customerNumber, 30 * secondsInDay, 'v2')).data.link);
                    setShowLink(true);
                } else if (parseInt(duration) !== 0) {
                    setLink((await api.customer_web_app_link(customerNumber, duration, 'v2')).data.link);
                    setShowLink(true);
                } else {
                    toast.success(`Facility created successfully`, {
                        position: 'top-center',
                        autoClose: 300,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        onClose: handleClose(),
                    });
                }
            }
        } catch {
            setError('An error happened during facility creation!');
        }
    };

    const handleClose = () => {
        setOpen(false);
        setLink('');
        setShowLink(false);
        setError('');
        setMarketOperator('');
        setPriceArea('');
        setDuration('None');

        loadCustomers(filter);
    };

    return (
        <Popup open={open} onClose={handleClose} modal className="modal">
            <div>
                <ToastContainer />
                <button className="modal__close" onClick={handleClose}>
                    &#10005;
                </button>
                <h6 className="modal__header"> Create facility </h6>
                <div className="modal__content">
                    <Input type="text" placeholder="Customer Number" onChange={e => setCustomerNumber(e.target.value)} fullWidth />
                    <Input type="text" placeholder="Facility Number" onChange={e => setFacilityNumber(e.target.value)} fullWidth />
                    <Input type="text" placeholder="Address" onChange={e => setAddress(e.target.value)} fullWidth />

                    <Select value={marketOperator} onChange={handleMarketOperatorChange} options={marketOperatorOptions} fullWidth />
                    <Select
                        value={priceArea}
                        onChange={e => setPriceArea(e.target.value)}
                        options={priceAreaOptions}
                        fullWidth
                        disabled={!marketOperator}
                    />
                    <Select value={duration} onChange={e => setDuration(e.target.value)} options={linkToWebApp} fullWidth />

                    {showLink && (
                        <div className="create-facility__success">
                            <div className="create-facility__success-message">
                                Your facility was successfully created! Please copy the link now because you won't be able to get it again!
                            </div>
                            <div className="create-facility__input-copy">
                                <a href={link} className="create-facility__link">
                                    {link.substring(0, 45)}...
                                </a>
                                <button className="create-facility__icon" onClick={() => navigator.clipboard.writeText(link)}>
                                    <img src="/assets/copy-icon.svg" title="Click to Copy" alt="Copy" />
                                </button>
                            </div>
                        </div>
                    )}

                    {error !== '' && <p className="create-facility__error-message">{error}</p>}
                </div>
                {!showLink && (
                    <div className="modal__actions">
                        <Button text="Create" onClick={createFacility} />
                        <Button className="modal__cancel" text="Cancel" onClick={handleClose} />
                    </div>
                )}
            </div>
        </Popup>
    );
};

export default CreateFacilityModal;
